import { __decorate } from "tslib";
import { Vue, Component } from 'vue-property-decorator';
import { Mutation } from 'vuex-class';
import { REQUEST } from '@/helpers/constants/Store';
const namespace = { namespace: REQUEST };
let RequestDetailsMixin = class RequestDetailsMixin extends Vue {
    constructor() {
        super(...arguments);
        this.selectedRequestUuid = null;
    }
    onViewRequest(requestUuid) {
        this.selectedRequestUuid = requestUuid;
        this.showRequestDetails();
    }
};
__decorate([
    Mutation('showRequestDetails', namespace)
], RequestDetailsMixin.prototype, "showRequestDetails", void 0);
RequestDetailsMixin = __decorate([
    Component
], RequestDetailsMixin);
export default RequestDetailsMixin;
